import { apiSlice } from "../../app/apiSlice";
import configUrls from "../../config/configUrls";
import { Bloco } from "../../types/bloco/Bloco";

const endpointUrl = configUrls.BLOCO_API_EP;  



function createBloco(obj: Bloco) {
    return {
        url: `${endpointUrl}/create`,
        method: "POST",
        body: obj,
    }
}

function updateBloco(obj: Bloco) {
    return {
        url: `${endpointUrl}/${obj.id}`,
        method: "PUT",
        body: obj,
    }
}

function deleteBloco({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/${id}`,
        method: "DELETE",
    }
}

function getBlocos(search: string) {
    return {
        url: `${endpointUrl}/filter?search=${search}`,
        method: "GET",
    }
}




export const blocoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getBloco: query<Bloco, string>({
            query: (id) => `${endpointUrl}/${id}`,
            providesTags: ["Bloco"],
        }),
        getBlocos: query<Bloco[], string>({
            query: getBlocos,
            providesTags: ["Bloco"],
        }),


        createBloco1: mutation<Bloco, Bloco>(
            {
                query: createBloco,
                invalidatesTags: ["Bloco"]
            }),


        createBloco: mutation<Bloco, Bloco>(
            {
                query: (obj) => ({
                    url: `${endpointUrl}/create`,  // Usando a variável endpointUrl diretamente
                    method: 'POST',    // Método POST para criar o bloco
                    body: obj,         // Corpo da requisição com os dados do novo bloco
                }),
                invalidatesTags: ["Bloco"]
            }),

        updateBloco: mutation<Bloco, Bloco>({
            query: updateBloco,
            invalidatesTags: ["Bloco"]
        }),

        deleteBloco: mutation<Bloco, { id: string }>(
            {
                query: deleteBloco,
                invalidatesTags: ["Bloco"],
            }),


    }),

});
export const {
    useGetBlocoQuery,
    useCreateBlocoMutation,
    useUpdateBlocoMutation,
    useDeleteBlocoMutation,
    useCreateBloco1Mutation,
    useGetBlocosQuery,
} = blocoApiSlice